import { useConfigSlice } from '../store';

export const getLobbyURL = (
  lobbyVersion: string | undefined,
  searchParams: string,
  options?: ILobbyURLOptions
): string => {
  let folder = 'lobby';
  if (lobbyVersion === '2') {
    folder = 'lobby2';
  }
  if (options?.folderOnly) {
    return folder;
  }
  return `/desktop/${folder}/${searchParams}`;
};

export interface ILobbyURLOptions {
  folderOnly?: boolean;
}

export const useLobbyURLConnected = (options?: ILobbyURLOptions): string => {
  const searchParams = useConfigSlice.urlParams();
  const lobbyVersion = useConfigSlice.casinoConfig()?.lobbyVersion;
  return getLobbyURL(lobbyVersion, searchParams, options);
};
